"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressTracker = ProgressTracker;
exports.ProgressTrackerItem = ProgressTrackerItem;
var _classnames = _interopRequireDefault(require("classnames"));
var React = _interopRequireWildcard(require("react"));
var _cardLevel = require("../../common/cardLevel");
var _classes = require("../../common/classes");
var _colors = require("../../common/colors");
var _intent = require("../../common/intent");
var _paddingLevel = require("../../common/paddingLevel");
var _Card = require("../card/Card");
var _Icon = require("../icon/Icon");
var _iconNames = require("../icon/iconNames");
var _IndicatorTag = require("../tag/IndicatorTag");
var _Tooltip = require("../tooltip/Tooltip");
var _typography = require("../typography/typography");
var _excluded = ["className", "fill", "items", "onClick", "outlined", "vertical"],
  _excluded2 = ["active", "className", "fill", "index", "id", "intent", "onClick", "outlined", "text", "vertical", "indicatorTagProps"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * Not thrilled with overriding the onClick handler, but struggled naming it something that doesnt clash with pre-existing handlers.
 * Time will tell if this is a stupid idea.
 */

function ProgressTracker(_ref) {
  var className = _ref.className,
    fill = _ref.fill,
    items = _ref.items,
    onClick = _ref.onClick,
    outlined = _ref.outlined,
    vertical = _ref.vertical,
    props = _objectWithoutProperties(_ref, _excluded);
  var filled = fill !== undefined ? fill : true;
  var classes = (0, _classnames.default)(_classes.Classes.PROGRESS_TRACKER, _defineProperty({}, _classes.Classes.FILL, filled), _defineProperty({}, _classes.Classes.VERTICAL, vertical), className);
  var currentIndex = items.findIndex(function (item) {
    return item.active === true;
  });
  var mayOutline = outlined !== undefined ? outlined : true;
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classes
  }, props), items.map(function (item, index) {
    return /*#__PURE__*/React.createElement(ProgressTrackerItem, _extends({
      fill: filled,
      key: item.id,
      index: index + 1,
      onClick: onClick
    }, item, {
      vertical: vertical,
      outlined: mayOutline && index <= currentIndex
    }));
  }));
}
function ProgressTrackerItem(_ref2) {
  var active = _ref2.active,
    className = _ref2.className,
    fill = _ref2.fill,
    index = _ref2.index,
    id = _ref2.id,
    intent = _ref2.intent,
    onClick = _ref2.onClick,
    outlined = _ref2.outlined,
    text = _ref2.text,
    vertical = _ref2.vertical,
    indicatorTagProps = _ref2.indicatorTagProps,
    props = _objectWithoutProperties(_ref2, _excluded2);
  function handleClick() {
    if (onClick !== undefined) onClick(id);
  }
  var classes = (0, _classnames.default)(className, _classes.Classes.PROGRESS_TRACKER_ITEM, _defineProperty({}, _classes.Classes.FILL, fill), _defineProperty({}, _classes.Classes.OUTLINED, outlined), _defineProperty({}, _classes.Classes.ACTIVE, active), _defineProperty({}, _classes.Classes.VERTICAL, vertical));
  var progressTrackerItemContent = /*#__PURE__*/React.createElement("div", {
    className: _classes.Classes.PROGRESS_TRACKER_ITEM_CONTENT
  }, /*#__PURE__*/React.createElement(ProgressItemIndicatorTag, {
    intent: intent || _intent.Intent.NONE,
    active: !!active,
    text: index,
    indicatorTagProps: indicatorTagProps
  }), /*#__PURE__*/React.createElement(_typography.Body, {
    color: _colors.Colors.GREY_80,
    className: _classes.Classes.TEXT_OVERFLOW_ELLIPSIS
  }, text));
  var tooltipWrapper = /*#__PURE__*/React.createElement(_Tooltip.Tooltip, {
    content: text,
    targetTagName: "div",
    wrapperTagName: "div"
  }, progressTrackerItemContent);
  return /*#__PURE__*/React.createElement(_Card.Card, _extends({
    level: _cardLevel.CardLevel.FILLED,
    paddingLevel: _paddingLevel.PaddingLevel.CONDENSED,
    onClick: handleClick,
    className: classes
  }, props), vertical ? progressTrackerItemContent : tooltipWrapper);
}
function ProgressItemIndicatorTag(_ref3) {
  var intent = _ref3.intent,
    active = _ref3.active,
    text = _ref3.text,
    indicatorTagProps = _ref3.indicatorTagProps;
  var intentPropsMap = {
    danger: {
      children: '!'
    },
    none: {
      children: text,
      minimal: !active,
      color: active ? _colors.Colors.EBONY_60 : _colors.Colors.IVORY_30
    },
    primary: {
      children: text
    },
    success: {
      icon: /*#__PURE__*/React.createElement(_Icon.Icon8, {
        icon: _iconNames.IconNames8.CHECK,
        fill: _colors.Colors.WHITE
      })
    },
    warning: {
      children: text
    }
  };
  var isOverridden = indicatorTagProps !== undefined;
  var tagProps = intentPropsMap[intent];
  var tagIntent = intent;
  if (isOverridden) {
    tagProps = _objectSpread({
      children: text
    }, indicatorTagProps);
    tagIntent = undefined;
  }
  return /*#__PURE__*/React.createElement(_IndicatorTag.IndicatorTag, {
    intent: tagIntent,
    small: true,
    minimal: tagProps.minimal,
    color: tagProps.color,
    icon: tagProps.icon,
    textColor: tagProps.textColor
  }, tagProps.children);
}